import type { IconSvgObject } from './types';

const ArrowRight05Icon: IconSvgObject = [
  ["path", { d: "M19.9981 6L19.9981 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.9981 12L11.9982 16L11.9981 8L16.9981 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 12H12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrowRight05Icon;
